import PlatformHeader from './PlatformHeader';
import './PlatformHeader.scss';

export default PlatformHeader;